var exports = {
  "kL": "FormSwitch.module__container___ajdMZV",
  "oE": "FormSwitch.module__compact___ajdMZV",
  "_A": "FormSwitch.module__labelContainer___ajdMZV",
  "Pf": "FormSwitch.module__label___ajdMZV",
  "r9": "FormSwitch.module__disabled___ajdMZV",
  "vk": "FormSwitch.module__clickable___ajdMZV",
  "h_": "FormSwitch.module__description___ajdMZV",
  "HV": "FormSwitch.module__switchRoot___ajdMZV",
  "L8": "FormSwitch.module__switchThumb___ajdMZV",
  "nL": "FormSwitch.module__iconChecked___ajdMZV",
  "ao": "FormSwitch.module__iconUnchecked___ajdMZV",
};

module.exports = exports;
